import React from 'react';
import { Navigate } from 'react-router-dom';
import { isReleased } from '@/utils/environment';

/**
 * Wraps a route's page so it opens only where `feature` is released
 * (PRE_RELEASE in src/utils/environment.ts); elsewhere it sends the person
 * Home. The page's code isn't downloaded there either, since lazy pages load
 * only when rendered.
 */
export const ReleaseGate = ({
  feature,
  children,
}: {
  feature: string;
  children: React.ReactNode;
}) => (isReleased(feature) ? children : <Navigate to="/home" replace />);
